import { FIELD_PRIMITIVE__bool } from '@shared/dto/generation/graph_invoke/_fields/_primitives/FIELD_PRIMITIVE__bool';
import { G_UI_FIELD_PRIMITIVE__bool_list_item } from './G_UI_FIELD_PRIMITIVE__bool_list_item';

interface PROPS {
  field: FIELD_PRIMITIVE__bool;
}

export function G_UI_FIELD_PRIMITIVE__bool_list({ field }: PROPS) {
  /*
   * RENDERS
   */
  function render_items() {
    let out: JSX.Element[] = [];

    for (let item_value_range of field.get_value_range()) {
      let field_value_range = field.clone({ value: item_value_range });

      let view = <G_UI_FIELD_PRIMITIVE__bool_list_item key={`${field.meta.field_id}_${item_value_range}`} field={field_value_range} />;

      out.push(view);
    }

    return out;
  }

  /*
   * HTML
   */

  return <div className="flex flex-col w-full min-w-0">{render_items()}</div>;
}
